import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { a11yHidden } from '../../../styles';
import { notFound } from '../assets';
import { isWebView, closeWebView } from '../../../utils';

const S = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100vh;
  `,
  Center: styled.div`
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
  `,
  Heading: styled.h2`
    ${a11yHidden}
  `,
  Paragraph: styled.p`
    margin-bottom: 24px;
    color: ${({ theme }) => theme.palette.grey[800]};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
  `,
  Figure: styled.figure`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 36px;
  `,
  ImageWrapper: styled.div`
    width: 320px;
    max-width: 64%;
  `,
  Image: styled.img`
    display: block;
    width: 100%;
    margin-bottom: 24px;
  `,
  Figcaption: styled.figcaption`
    color: ${({ theme }) => theme.palette.grey[800]};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    line-height: 1.53;
    text-align: center;
  `,
  Actions: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    & > :not(:first-child) {
      margin-left: 8px;
    }
  `,
  Link: styled(Button).attrs(() => ({ component: Link }))`
    padding: 0 24px;
    height: 36px;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  `,
  ActionBar: styled.header`
    display: flex;
    align-items: center;
    min-height: 56px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
    padding: 0 12px;
    background-color: ${({ theme }) => theme.palette.primary.contrastText};
    width: 100%;
  `,
  ArrowBack: styled(ArrowBack)`
    color: ${({ theme }) => theme.palette.grey[600]};
  `,
};

const NotFound = () => {
  const history = useHistory();

  const handleBackButton = () => {
    if (isWebView()) {
      closeWebView();
    } else {
      history.goBack();
    }
  };

  return (
    <S.Wrapper>
      <S.ActionBar>
        <IconButton type="button" size="small" onClick={handleBackButton}>
          <S.ArrowBack />
        </IconButton>
      </S.ActionBar>
      <S.Center>
        <S.Heading>404 Not Found</S.Heading>
        <S.Paragraph>
          죄송합니다.
          <br />
          현재 찾을 수 없는 페이지를 요청하셨습니다.
        </S.Paragraph>
        <S.Figure>
          <S.ImageWrapper>
            <S.Image src={notFound} alt="" />
          </S.ImageWrapper>
          <S.Figcaption>
            존재하지 않는 주소를 입력하셨거나
            <br />
            요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.
          </S.Figcaption>
        </S.Figure>
        <S.Actions>
          <S.Link
            to="/school-newsletters"
            variant="outlined"
            color="secondary"
            replace
          >
            목록으로
          </S.Link>
        </S.Actions>
      </S.Center>
    </S.Wrapper>
  );
};

export default NotFound;
